import { AllnetAPI, computed } from "aaa";
import { action, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { IEvaluation, IGetEvaluationsResponse } from "types/allnetServices";

export class AssetCalculationStore {
    @observable _isLoading = true;
    @observable evaluationsResponse?: IGetEvaluationsResponse;

    @computed get isLoading() {
        return this._isLoading;
    }

    @action async loadData() {

        try {
            this._isLoading = true;

            const target = AllnetAPI.getEvaluations();
            this.evaluationsResponse = await NetbankingAPIClient.requestType(target);

            this._isLoading = false;
        } catch (error) {
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/assetCalculation/AssetCalculationStore.ts